import makerjs, {IModel} from "makerjs";
import {ValidatorInterface} from "./ValidatorInterface";
import { AbstractValidator, ValidatorObject } from "./AbstractValidator";

interface OffsetValidatorObject extends ValidatorObject {
	modelInstance?: IModel;
	parentModelInstance?: IModel;
	minOffsetInMM?: number;
}

export class Offset extends AbstractValidator implements ValidatorInterface {
	private readonly modelA: IModel;
	private readonly modelB: IModel;
	private readonly minOffsetInMM: number;

	private originalShapeModel: IModel;
	public offset: IModel;

	constructor( options: OffsetValidatorObject ) {
		super( options );

		this.modelA = options.parentModelInstance;
		this.modelB = options.modelInstance;
		this.minOffsetInMM = options.minOffsetInMM ?? 20;

		this.createOriginalShapeModel();
	}

	createOriginalShapeModel(): void {
		const clone = makerjs.cloneObject( this.modelA );

		// Remove a small margin from the offset to account for cutouts being exactly on the offset and thus valid.
		const outline = makerjs.model.outline( clone, this.minOffsetInMM - .1, 0, true );
		makerjs.model.addModel( clone, outline, 'outline' );
		this.originalShapeModel = clone;
	}

	hasObjectsWithinOffset(): boolean {
		const result = makerjs.model.combine(makerjs.cloneObject(this.modelB), makerjs.cloneObject(this.originalShapeModel), true, false, false, false);
		let hasPaths = false;
		makerjs.model.walk(result.models.a, {
			onPath: (modelContext: any) => {
				hasPaths = true;
			}
		});

		return hasPaths;
	}

	getMessage(): string {
		const { generic } = window.measurementSelectorVariables.i18n.validators;

		return super.getCustomMessage() ?? generic.offset.all;
	}

	isValid(): boolean {
		return this.hasObjectsWithinOffset() === false;
	}

	isIgnorableModel(): boolean {
		return [
			'grid-drillHole',
			'radial-drillHole',
			'edge-drillHoles-around',
			'edge-drillHoles-corners',
			'drillhole'
		].includes( this.modelB.type ) === false;
	}
}
